import { render, staticRenderFns } from "./LifeCycle.vue?vue&type=template&id=9f05e6a4"
import script from "./LifeCycle.vue?vue&type=script&lang=js"
export * from "./LifeCycle.vue?vue&type=script&lang=js"
import style0 from "./LifeCycle.vue?vue&type=style&index=0&id=9f05e6a4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports